<template>
  <b-row>
    <b-col
      md="3"
      v-for="(champs, index) in displayedValue"
      class="value_block_container"
      v-bind:key="index"
    >
      <div class="inner_value_block">
        <b-button-group style="width: 100%">
          <b-button
            v-on:click="shiftLeft(index)"
            style="float: right; margin-bottom: 10px"
          >
            <v-icon name="chevron-left" />
          </b-button>
          <b-button
            v-on:click="shiftRight(index)"
            style="float: right; margin-bottom: 10px"
          >
            <v-icon name="chevron-right" />
          </b-button>
          <b-button
            v-on:click="switchAlign(index)"
            style="float: right; margin-bottom: 10px"
          >
            <v-icon name="align-left" />
          </b-button>
          <b-button
            v-on:click="switchColor(index)"
            style="float: right; margin-bottom: 10px"
          >
            <v-icon name="palette" />
          </b-button>
          <b-button
            v-on:click="deleteBlock(index)"
            style="float: right; margin-bottom: 10px"
            >x</b-button
          >
        </b-button-group>

        <p class="value_block_property">
          Alignement : <b>{{ champs.align }}</b>
        </p>
        <p class="value_block_property">
          Couleur : <b>{{ champs.sexColor }}</b>
        </p>

        <b-form-input
          class="value_block_name"
          size="sm"
          v-model="champs.entete"
          @change="emitUpdate"
          placeholder="Nom de la colonne"
          style="border: 2px solid #f29406; margin-bottom: 20px"
        ></b-form-input>

        <draggable
          class="list-group"
          :list="champs.values"
          group="people"
          @change="emitUpdate"
        >
          <div
            class="list-group-item"
            v-for="(element, index_meta) in champs.values"
            :key="element.name"
          >
            {{ element.name }}
            <b-button v-on:click="deleteMetaField(index, index_meta)"
              >x</b-button
            >
          </div>
        </draggable>
      </div>
    </b-col>
  </b-row>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: { draggable },
  props: ["displayedValue"],
  data() {
    return {};
  },
  methods: {
    /* Changer l'alignement d'un champs */
    switchAlign(ind) {
      if (this.displayedValue[ind].align === "gauche") {
        this.displayedValue[ind].align = "centre";
      } else {
        this.displayedValue[ind].align = "gauche";
      }
      this.emitUpdate();
    },

    /* Changer la couleur d'un champs */
    switchColor(ind) {
      if (this.displayedValue[ind].sexColor === "oui") {
        this.displayedValue[ind].sexColor = "non";
      } else {
        this.displayedValue[ind].sexColor = "oui";
      }
      this.emitUpdate();
    },

    /* Déplacer un champs a gauche */
    shiftLeft(ind) {
      var champs = this.displayedValue[ind];
      this.displayedValue.splice(ind, 1);
      this.displayedValue.splice(ind - 1, 0, champs);
      this.emitUpdate();
    },

    /* Déplacer un champs a droite */
    shiftRight(ind) {
      var champs = this.displayedValue[ind];
      this.displayedValue.splice(ind, 1);
      this.displayedValue.splice(ind + 1, 0, champs);
      this.emitUpdate();
    },

    deleteMetaField(index, index_meta) {
      this.displayedValue[index].values.splice(index_meta, 1);
      this.emitUpdate();
    },
    deleteBlock(index) {
      this.displayedValue.splice(index, 1);
      this.emitUpdate();
    },
    emitUpdate() {
      this.$emit("updatePrevisualisation");
    },
  },
};
</script>

<style>
.value_block_container {
  padding: 5px;
}
.inner_value_block {
  -webkit-box-shadow: 0px 0px 3px 1px rgba(155, 155, 155, 0.4);
  -moz-box-shadow: 0px 0px 3px 1px rgba(155, 155, 155, 0.4);
  box-shadow: 0px 0px 3px 1px rgba(155, 155, 155, 0.4);
  border: 1px solid #646464;
  border-radius: 4px;
  overflow: hidden;
}

.value_block_property {
  text-align: center;
  font-weight: normal;
  margin-bottom: 5px;
  line-height: 16px;
}

.inner_value_block .btn-group button {
  border-radius: 0 !important;
}

.inner_value_block .btn-group button:focus,
.inner_value_block .btn-group button:active {
  box-shadow: none !important;
}
.value_block_name {
  margin: 0 3%;
  width: 94%;
}
.list-group {
  margin: 4px 3%;
}
</style>